import React from 'react';
import PageRouter from './components/page-router/page-router';

const Routes = () => {
  return (
    <div style={{ width: '100%', overflow: 'hidden' }}>
      <PageRouter />
    </div>
  );
};

export default Routes;
